import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";
import { RECRUITER_KEYS } from "./keys";
import toFormData from "./toFormData";

/**
 * Save the recruiter's identity, contact details and branding.
 *
 * Settings have their own hook (useMutateRecruiterSettings) and their own
 * endpoint; do not route settings fields through here.
 */
export default function useMutateRecruiter() {
  const api = useAxios();
  const client = useQueryClient();

  return {
    mutation: useMutation({
      mutationFn: (recruiter: Record<string, unknown> & { id: string }) =>
        api.post(`/recruiter/${recruiter.id}`, toFormData(recruiter), {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }),
      onSuccess: () => {
        // Only the recruiter key. Invalidating the settings key as well would
        // settle two refetches, and the Settings dialog only absorbs one.
        client.invalidateQueries({ queryKey: RECRUITER_KEYS.details() });
      },
    }),
    clearQuery: () =>
      client.invalidateQueries({ queryKey: RECRUITER_KEYS.details() }),
  };
}
